import { render } from "./FormCreatePage.vue?vue&type=template&id=0d04c894&scoped=true"
import script from "./FormCreatePage.vue?vue&type=script&lang=js"
export * from "./FormCreatePage.vue?vue&type=script&lang=js"

import "./FormCreatePage.vue?vue&type=style&index=0&id=0d04c894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d04c894"]])

export default __exports__